// ProductDetails.js
import React, { useState, useMemo, useEffect } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { useSwipeable } from "react-swipeable";
import { getAProduct, getAllProducts } from "../features/products/productSlice";
import Footer from "./Footer";
import axios from "../utils/axios";
import "../asset/productdetal.css";
import { addToCart } from "../redux/actions/cartAction";
import SwiperCore from "swiper";
import AdComponent1 from "./AdComponent1";
import { AiOutlineZoomIn, AiOutlineClose } from "react-icons/ai";
import "swiper/css/bundle";
import RelatedProducts from "./RelatedProducts";
import { Swiper, SwiperSlide } from "swiper/react";
import { toast } from "react-toastify";
import "../index.css";
import "../App.css";
import { base_url } from "../utils/axiosConfig";
import { FaShareFromSquare } from "react-icons/fa6";

SwiperCore.use([Navigation, Pagination, Autoplay]);

const PD_STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');

  .pd-wrapper {
    font-family: 'Inter', sans-serif;
    background: #f8fafc;
    min-height: 100vh;
    padding-top: 8px;
  }
  @media (max-width: 768px) { .pd-wrapper { padding-top: 0; } }

  /* ── BREADCRUMB ── */
  .pd-breadcrumb {
    max-width: 1360px; margin: 0 auto;
    padding: 10px 24px 0;
    display: flex; align-items: center; gap: 8px;
    font-size: 11px; color: #94a3b8; font-weight: 500;
  }
  @media (max-width: 480px) { .pd-breadcrumb { display: none; } }
  .pd-breadcrumb a { color: #94a3b8; text-decoration: none; transition: color 0.2s; }
  .pd-breadcrumb a:hover { color: #14b8a6; }
  .pd-breadcrumb span { color: #1e293b; font-weight: 600; }

  /* ── MAIN SECTION ── */
  .pd-main {
    max-width: 1360px; margin: 0 auto;
    padding: 12px 20px 32px;
    display: grid;
    grid-template-columns: 1.1fr 0.9fr;
    gap: 40px;
    align-items: start;
  }
  @media (max-width: 900px) {
    .pd-main { grid-template-columns: 1fr; gap: 0; padding: 0 0 32px; }
  }

  /* ── LEFT: IMAGE GALLERY ── */
  .pd-gallery { position: sticky; top: 90px; }
  @media (max-width: 900px) { .pd-gallery { position: static; } }

  .pd-gallery__main {
    background: #fff;
    border-radius: 24px;
    border: 1px solid #e2e8f0;
    overflow: hidden;
    aspect-ratio: 1/1;
    display: flex; align-items: center; justify-content: center;
    position: relative;
    cursor: zoom-in;
    box-shadow: 0 2px 16px rgba(0,0,0,0.06);
  }
  @media (max-width: 900px) { .pd-gallery__main { border-radius: 0; border-inline: none; border-top: none; box-shadow: none; } }
  
  .pd-gallery__main-img {
    max-width: 100%; max-height: 100%;
    object-fit: contain;
    padding: 20px;
    transition: transform 0.4s ease;
    display: block;
  }
  .pd-gallery__main-img.zoomed { transform: scale(1.5); cursor: zoom-out; }

  .pd-gallery__zoom-btn {
    position: absolute; top: 14px; right: 14px;
    width: 42px; height: 42px;
    background: rgba(255,255,255,0.92);
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer; color: #475569;
    box-shadow: 0 2px 12px rgba(0,0,0,0.1);
    transition: all 0.2s;
    z-index: 5;
    backdrop-filter: blur(8px);
  }
  .pd-gallery__zoom-btn:hover { background: #14b8a6; color: #fff; border-color: #14b8a6; transform: scale(1.08); }

  .pd-gallery__counter {
    position: absolute; bottom: 14px; left: 50%; transform: translateX(-50%);
    background: rgba(15,23,42,0.7);
    color: #fff; font-size: 11px; font-weight: 700;
    padding: 4px 14px; border-radius: 100px;
    backdrop-filter: blur(6px);
    z-index: 5;
  }

  .pd-gallery__thumbs {
    display: flex; gap: 12px; margin-top: 14px;
    overflow-x: auto; padding: 0 20px 10px;
    scrollbar-width: none; -ms-overflow-style: none;
  }
  @media (max-width: 900px) { .pd-gallery__thumbs { margin-top: 10px; } }
  .pd-gallery__thumbs::-webkit-scrollbar { display: none; }
  .pd-gallery__thumb {
    width: 64px; height: 64px; flex-shrink: 0;
    border-radius: 12px; overflow: hidden;
    border: 2px solid #e2e8f0;
    background: #fff; cursor: pointer;
    transition: all 0.2s;
  }
  .pd-gallery__thumb.active { border-color: #14b8a6; border-width: 3px; }

  /* ── LIGHTBOX ── */
  .pd-lightbox {
    position: fixed; inset: 0;
    background: rgba(0,0,0,0.88);
    z-index: 99999;
    display: flex; align-items: center; justify-content: center;
    animation: pdFadeIn 0.25s ease;
    backdrop-filter: blur(8px);
  }
  @keyframes pdFadeIn { from { opacity: 0; } to { opacity: 1; } }
  .pd-lightbox__inner {
    position: relative; max-width: 92vw;
    display: flex; flex-direction: column; align-items: center; gap: 20px;
  }
  .pd-lightbox__img {
    max-height: 80vh; max-width: 100%;
    object-fit: contain;
    border-radius: 16px;
    box-shadow: 0 24px 80px rgba(0,0,0,0.5);
    transition: transform 0.3s ease;
  }
  .pd-lightbox__img.zoomed { transform: scale(1.4); cursor: zoom-out; }
  .pd-lightbox__close {
    position: absolute; top: -54px; right: 0;
    width: 44px; height: 44px;
    background: rgba(255,255,255,0.12);
    border: 1px solid rgba(255,255,255,0.2);
    border-radius: 12px;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer; color: #fff; font-size: 20px;
    transition: background 0.2s;
    z-index: 10;
  }
  .pd-lightbox__close:hover { background: #ef4444; }
  .pd-lightbox__nav {
    position: absolute; top: 50%; transform: translateY(-50%);
    width: 48px; height: 48px;
    background: rgba(255,255,255,0.13);
    border: 1px solid rgba(255,255,255,0.2);
    border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer; color: #fff; font-size: 20px;
    transition: all 0.2s; z-index: 10;
  }
  .pd-lightbox__nav:hover { background: rgba(20,184,166,0.7); }
  .pd-lightbox__nav--prev { left: -64px; }
  .pd-lightbox__nav--next { right: -64px; }
  @media (max-width: 600px) {
    .pd-lightbox__nav--prev { left: 8px; }
    .pd-lightbox__nav--next { right: 8px; }
  }
  .pd-lightbox__counter {
    color: rgba(255,255,255,0.6);
    font-size: 13px; font-weight: 600;
  }

  /* ── RIGHT: PRODUCT INFO ── */
  .pd-info {
    background: #fff;
    border-radius: 28px;
    border: 1px solid #e2e8f0;
    padding: 36px;
    box-shadow: 0 4px 24px rgba(0,0,0,0.04);
    position: sticky; top: 10px;
  }
  @media (max-width: 900px) { .pd-info { padding: 24px 20px 100px; border-radius: 0; border: none; box-shadow: none; position: static; } }
  @media (max-width: 480px) { .pd-info { padding: 18px 16px 120px; } }

  .pd-badge-list { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 20px; }
  .pd-medical-badge { 
    display: inline-flex; align-items: center; gap: 6px; 
    padding: 6px 12px; border-radius: 100px; font-size: 11px; font-weight: 800;
    text-transform: uppercase; letter-spacing: 0.04em;
  }
  .pd-badge--verified { background: #f0fdf4; color: #166534; border: 1px solid #bbf7d0; }
  .pd-badge--certified { background: #eff6ff; color: #1e40af; border: 1px solid #bfdbfe; }

  .pd-info__category {
    display: inline-flex; align-items: center; gap: 6px;
    background: #f0fdfa; color: #0d9488;
    font-size: 10px; font-weight: 800; letter-spacing: 0.22em;
    text-transform: uppercase; padding: 5px 14px; border-radius: 100px;
    border: 1px solid #ccfbf1; margin-bottom: 16px;
  }

  .pd-info__title {
    font-size: clamp(1.4rem, 3.5vw, 2.2rem);
    font-weight: 900; color: #0f172a;
    line-height: 1.15; letter-spacing: -0.02em;
    margin: 0 0 20px;
  }

  /* Pricing row */
  .pd-info__price-row {
    display: flex; align-items: center; justify-content: space-between;
    gap: 12px; margin-bottom: 20px; flex-wrap: wrap;
  }
  .pd-info__price-group { display: flex; align-items: baseline; gap: 12px; flex-wrap: wrap; }
  .pd-info__price {
    font-size: 2rem; font-weight: 900; color: #0f172a;
    line-height: 1;
  }
  @media (max-width: 480px) { .pd-info__price { font-size: 1.6rem; } }
  .pd-info__currency { font-size: 1rem; font-weight: 600; color: #475569; margin-left: 4px; }
  .pd-info__old-price {
    font-size: 1.1rem; color: #f87171; text-decoration: line-through;
    font-weight: 600; opacity: 0.75;
  }
  .pd-info__share {
    width: 44px; height: 44px; border-radius: 14px;
    background: #f8fafc; border: 1.5px solid #e2e8f0;
    display: flex; align-items: center; justify-content: center;
    color: #64748b; cursor: pointer; transition: all 0.2s;
    flex-shrink: 0;
  }
  .pd-info__share:hover { background: #14b8a6; color: #fff; border-color: #14b8a6; transform: scale(1.06); }

  /* Divider */
  .pd-divider { height: 1px; background: linear-gradient(90deg, #e2e8f0 0%, #f8fafc 100%); margin: 20px 0; }

  /* Description */
  .pd-info__desc {
    font-size: 14px; color: #64748b; line-height: 1.75;
    margin-bottom: 8px;
  }
  .pd-info__desc-full { }
  .pd-info__desc-clamped {
    display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden;
  }
  .pd-info__read-more {
    font-size: 13px; font-weight: 800; color: #14b8a6;
    background: none; border: none; cursor: pointer;
    padding: 4px 0; margin-bottom: 24px;
    display: flex; align-items: center; gap: 4px;
    transition: transform 0.2s;
  }
  .pd-info__read-more:hover { transform: translateX(4px); }

  /* ── PHARMACY FIELDS ── */
  .pd-pharmacy-row {
    display: flex; flex-wrap: wrap; gap: 12px; margin-bottom: 24px;
  }
  .pd-strength-badge {
    display: inline-flex; align-items: center; gap: 8px;
    background: #f0fdfa; border: 1.5px solid #a7f3d0;
    padding: 8px 16px; border-radius: 12px;
    font-size: 14px; font-weight: 800; color: #0d9488;
  }
  .pd-presc-warning {
    background: linear-gradient(135deg, #fef2f2 0%, #fff 100%);
    border: 1.5px solid #fecaca;
    padding: 16px 20px; border-radius: 18px;
    display: flex; flex-direction: column; gap: 12px;
    margin-bottom: 24px;
    box-shadow: 0 4px 12px rgba(220, 38, 38, 0.05);
  }
  .pd-presc-top { display: flex; align-items: center; gap: 10px; }
  .pd-presc-text { font-size: 13px; font-weight: 700; color: #991b1b; line-height: 1.5; }
  .pd-upload-btn {
    width: 100%; padding: 10px; background: #991b1b; color: #fff;
    border: none; border-radius: 10px; font-size: 11px; font-weight: 800;
    text-transform: uppercase; letter-spacing: 0.1em; cursor: pointer;
    display: flex; align-items: center; justify-content: center; gap: 8px;
    transition: background 0.2s;
  }
  .pd-upload-btn:hover { background: #7f1d1d; }

  /* Prescription Plans */
  .pd-plans__title {
    font-size: 14px; font-weight: 800; color: #0f172a;
    text-transform: uppercase; letter-spacing: 0.1em;
    margin-bottom: 14px; display: flex; align-items: center; gap: 8px;
  }
  .pd-plans__grid {
    display: grid; grid-template-columns: 1fr; gap: 10px; margin-bottom: 24px;
  }
  .pd-plan-card {
    background: #fff; border: 1.5px solid #e2e8f0; border-radius: 16px;
    padding: 16px; cursor: pointer; transition: all 0.25s;
    display: flex; align-items: center; justify-content: space-between;
    position: relative; overflow: hidden;
  }
  .pd-plan-card.active { border-color: #14b8a6; background: #f0fdfa; box-shadow: 0 4px 15px rgba(20,184,166,0.1); }
  .pd-plan-card:hover:not(.active) { border-color: #99f6e4; background: #fafafa; }
  .pd-plan-name { font-size: 15px; font-weight: 800; color: #0f172a; margin-bottom: 4px; }
  .pd-plan-duration { font-size: 12px; color: #64748b; font-weight: 600; }
  .pd-plan-price { font-size: 16px; font-weight: 900; color: #14b8a6; }
  .pd-plan-check {
    width: 22px; height: 22px; border-radius: 50%;
    border: 2px solid #e2e8f0; display: flex; align-items: center; justify-content: center;
    color: transparent; transition: all 0.2s; flex-shrink: 0;
  }
  .pd-plan-card.active .pd-plan-check { background: #14b8a6; border-color: #14b8a6; color: #fff; }

  /* ── SELECTION GRID ── */
  .pd-sel__section { margin-bottom: 24px; }
  .pd-sel__label {
    font-size: 12px; font-weight: 800; color: #94a3b8;
    text-transform: uppercase; letter-spacing: 0.12em;
    margin-bottom: 12px; display: block;
  }
  .pd-sel__grid { display: flex; flex-wrap: wrap; gap: 10px; }
  .pd-sel__chip {
    padding: 10px 20px; border-radius: 12px;
    border: 1.5px solid #e2e8f0; background: #f8fafc;
    font-size: 13px; font-weight: 700; color: #475569;
    cursor: pointer; transition: all 0.2s;
  }
  .pd-sel__chip.active { background: #1e293b; border-color: #1e293b; color: #fff; transform: translateY(-2px); box-shadow: 0 4px 12px rgba(0,0,0,0.15); }
  .pd-sel__chip:hover:not(.active) { border-color: #14b8a6; color: #14b8a6; background: #fff; }

  /* ── ACTIONS ── */
  .pd-actions { display: grid; grid-template-columns: 140px 1fr; gap: 16px; margin-top: 32px; }
  @media (max-width: 480px) { .pd-actions { grid-template-columns: 1fr; } }

  .pd-qty {
    display: flex; align-items: center; justify-content: space-between;
    background: #f1f5f9; border-radius: 16px; padding: 6px;
    border: 1.5px solid #e2e8f0;
  }
  .pd-qty__btn {
    width: 38px; height: 38px; border-radius: 12px;
    background: #fff; border: 1px solid #e2e8f0;
    display: flex; align-items: center; justify-content: center;
    font-size: 18px; font-weight: 700; color: #1e293b;
    cursor: pointer; transition: all 0.2s;
  }
  .pd-qty__btn:hover:not(:disabled) { background: #14b8a6; color: #fff; border-color: #14b8a6; }
  .pd-qty__btn:disabled { opacity: 0.4; cursor: not-allowed; }
  .pd-qty__val { font-size: 17px; font-weight: 800; color: #1e293b; width: 30px; text-align: center; }

  .pd-btn-cart {
    background: linear-gradient(135deg, #14b8a6, #0d9488);
    color: #fff; border: none; border-radius: 16px;
    font-size: 16px; font-weight: 800; letter-spacing: 0.04em;
    cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 12px;
    transition: all 0.3s;
    box-shadow: 0 8px 25px rgba(20,184,166,0.35);
  }
  .pd-btn-cart:hover { transform: translateY(-2px); box-shadow: 0 12px 35px rgba(20,184,166,0.45); }
  .pd-btn-cart:active { transform: scale(0.97); }
  .pd-btn-cart:disabled { opacity: 0.6; cursor: not-allowed; transform: none; box-shadow: none; }

  /* ── STICKY BAR ── */
  .pd-sticky-bar {
    position: fixed; bottom: 0; left: 0; right: 0;
    background: #fff; border-top: 1px solid #e2e8f0;
    padding: 12px 16px; z-index: 1000;
    display: none; align-items: center; justify-content: space-between; gap: 12px;
    box-shadow: 0 -10px 30px rgba(0,0,0,0.06);
    animation: pdSlideUp 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
  @keyframes pdSlideUp { from { transform: translateY(100%); } to { transform: translateY(0); } }
  @media (max-width: 900px) { .pd-sticky-bar { display: flex; } }
  .pd-sticky-info { display: flex; flex-direction: column; }
  .pd-sticky-price { font-size: 18px; font-weight: 900; color: #0f172a; }
  .pd-sticky-label { font-size: 10px; font-weight: 700; color: #94a3b8; text-transform: uppercase; }
  .pd-sticky-btn { 
    flex: 1; height: 50px; border-radius: 14px; font-size: 14px; font-weight: 800;
    display: flex; align-items: center; justify-content: center; gap: 8px;
    background: #0f172a; color: #fff; border: none;
  }

  /* Store & Delivery info */
  .pd-extra {
    margin-top: 32px; padding: 20px; border-radius: 20px;
    background: #fafafa; border: 1.5px solid #f1f5f9;
    display: grid; grid-template-columns: 1fr 1fr; gap: 20px;
  }
  @media (max-width: 480px) { .pd-extra { grid-template-columns: 1fr; } }
  .pd-extra__item { display: flex; align-items: center; gap: 12px; }
  .pd-extra__ico {
    width: 40px; height: 40px; border-radius: 12px;
    background: #fff; border: 1px solid #e2e8f0;
    display: flex; align-items: center; justify-content: center;
    font-size: 18px; flex-shrink: 0; box-shadow: 0 2px 8px rgba(0,0,0,0.03);
  }
  .pd-extra__title { font-size: 12px; font-weight: 800; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.06em; margin-bottom: 2px; }
  .pd-extra__val { font-size: 14px; font-weight: 700; color: #1e293b; }

  .pd-info__desc-toggle {
    background: none; border: none; cursor: pointer;
    color: #14b8a6; font-weight: 700; font-size: 13px;
    font-family: 'Inter', sans-serif;
    display: inline-flex; align-items: center; gap: 4px;
    padding: 0; transition: color 0.2s; margin-top: 6px;
  }
  .pd-info__desc-toggle:hover { color: #0d9488; }

  /* Brand / meta */
  .pd-info__meta {
    display: flex; align-items: center; gap: 10px;
    font-size: 13px; color: #64748b; margin-bottom: 4px;
  }
  .pd-info__meta strong { color: #1e293b; font-weight: 700; }
  .pd-info__meta-dot {
    width: 4px; height: 4px; background: #e2e8f0; border-radius: 50%;
  }

  /* Selection */
  .pd-section { margin-bottom: 22px; }
  .pd-section__label {
    font-size: 12px; font-weight: 800; letter-spacing: 0.18em;
    text-transform: uppercase; color: #94a3b8; margin-bottom: 12px;
  }
  .pd-chips { display: flex; flex-wrap: wrap; gap: 10px; }
  .pd-chip {
    min-width: 64px; padding: 9px 18px;
    border: 2px solid #e2e8f0; border-radius: 100px;
    background: #fff; font-size: 13px; font-weight: 600;
    font-family: 'Inter', sans-serif; color: #475569;
    cursor: pointer; transition: all 0.2s;
    text-align: center;
  }
  .pd-chip:hover { border-color: #99f6e4; color: #14b8a6; background: #f0fdfa; }
  .pd-chip.active {
    border-color: #14b8a6; color: #0d9488;
    background: linear-gradient(135deg, #f0fdfa 0%, #e6fffa 100%);
    box-shadow: 0 0 0 3px rgba(20,184,166,0.12);
    font-weight: 800;
  }
  @media (max-width: 480px) {
    .pd-chip { padding: 8px 14px; font-size: 12px; min-width: 56px; }
  }

  /* CTA Buttons */
  .pd-cta { display: flex; flex-direction: column; gap: 12px; margin-top: 28px; }
  @media (min-width: 480px) { .pd-cta { flex-direction: row; } }
  .pd-btn {
    flex: 1; padding: 16px 20px;
    border: none; border-radius: 16px;
    font-size: 13px; font-weight: 800; font-family: 'Inter', sans-serif;
    letter-spacing: 0.14em; text-transform: uppercase;
    cursor: pointer; transition: all 0.25s;
    display: flex; align-items: center; justify-content: center; gap: 8px;
  }
  .pd-btn--cart {
    background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);
    color: #fff;
    box-shadow: 0 8px 28px rgba(20,184,166,0.35);
  }
  .pd-btn--cart:hover { transform: translateY(-2px); box-shadow: 0 14px 40px rgba(20,184,166,0.45); }
  .pd-btn--cart:active { transform: scale(0.97); }
  .pd-btn--order {
    background: #0f172a;
    color: #fff;
    box-shadow: 0 8px 28px rgba(15,23,42,0.25);
  }
  .pd-btn--order:hover { background: #1e293b; transform: translateY(-2px); box-shadow: 0 14px 36px rgba(15,23,42,0.35); }
  .pd-btn--order:active { transform: scale(0.97); }
  @media (max-width: 360px) {
    .pd-btn { padding: 14px 16px; font-size: 12px; }
  }

  /* Trust badges */
  .pd-trust {
    display: flex; flex-wrap: wrap; gap: 12px;
    margin-top: 24px; padding-top: 20px;
    border-top: 1px solid #f1f5f9;
  }
  .pd-trust__item {
    display: flex; align-items: center; gap: 7px;
    font-size: 12px; font-weight: 600; color: #64748b;
  }
  .pd-trust__icon {
    width: 30px; height: 30px; border-radius: 8px;
    background: #f0fdfa; display: flex; align-items: center; justify-content: center;
    color: #14b8a6; flex-shrink: 0; font-size: 14px;
  }

  /* Toast notification */
  .pd-toast {
    position: fixed; top: 88px; right: 20px;
    background: #fff; color: #0d9488;
    font-weight: 700; font-size: 14px;
    padding: 14px 20px; border-radius: 14px;
    box-shadow: 0 8px 40px rgba(0,0,0,0.14);
    z-index: 50000;
    border-left: 4px solid #14b8a6;
    animation: pdSlideIn 0.3s ease;
    font-family: 'Inter', sans-serif;
    max-width: 320px;
  }
  @keyframes pdSlideIn {
    from { transform: translateX(120%); opacity: 0; }
    to { transform: translateX(0); opacity: 1; }
  }

  /* Loading spinner */
  .pd-loading {
    display: flex; flex-direction: column;
    align-items: center; justify-content: center;
    min-height: 70vh; gap: 20px;
    background: #f8fafc;
  }
  .pd-spinner {
    width: 52px; height: 52px;
    border: 4px solid #e2e8f0;
    border-top-color: #14b8a6;
    border-radius: 50%;
    animation: pdSpin 0.8s linear infinite;
  }
  @keyframes pdSpin { to { transform: rotate(360deg); } }
  .pd-loading__label { font-size: 14px; color: #94a3b8; font-weight: 600; font-family: 'Inter', sans-serif; }

  /* Bottom section */
  .pd-bottom {
    max-width: 1360px; margin: 0 auto;
    padding: 0 20px 40px;
  }
  .pd-bottom__section { margin-bottom: 32px; }
`;

const ProductDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isFilled, setIsFilled] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [isExpanded, setIsExpanded] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isZoomed, setIsZoomed] = useState(false);
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [allImages, setAllImages] = useState([]);
  const [colorDetails, setColorDetails] = useState([]);
  const [selectedColorIndex, setSelectedColorIndex] = useState(null);
  const [selectedColor, setSelectedColor] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [prescriptionImages, setPrescriptionImages] = useState([]);
  const [uploadingRx, setUploadingRx] = useState(false);
  const [rxDragOver, setRxDragOver] = useState(false);


  const { singleproduct, isLoading } = useSelector((state) => state?.product);
  const wishlistState = useSelector((state) => state?.auth?.wishlist?.wishlist);

  useEffect(() => {
    if (singleproduct?.colors) {
      const images = singleproduct.colors.flatMap((c) => c.images || []);
      setAllImages(images);
    }
  }, [singleproduct]);

  const getToken = useMemo(() => {
    return localStorage.getItem("customer")
      ? JSON.parse(localStorage.getItem("customer"))
      : null;
  }, []);

  const config2 = useMemo(
    () => ({
      headers: {
        Authorization: `Bearer ${getToken ? getToken.token : ""}`,
        Accept: "application/json",
      },
    }),
    [getToken],
  );

  useEffect(() => {
    dispatch(getAProduct(id)).unwrap().catch(console.error);
    dispatch(getAllProducts()).unwrap().catch(console.error);
  }, [dispatch, id, config2]);

  const handlePrescriptionUpload = async (files) => {
    if (!files || files.length === 0) return;
    setUploadingRx(true);
    try {
      const formData = new FormData();
      Array.from(files).forEach((file) => formData.append("multiple_image", file));
      const response = await fetch(`${base_url}upload/create`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${getToken ? getToken.token : ""}`,
        },
        body: formData,
      });
      const data = await response.json();
      if (data && data.length > 0) {
        setPrescriptionImages((prev) => [...prev, ...data]);
        toast.success(`✅ ${data.length} prescription image${data.length > 1 ? "s" : ""} uploaded!`);
      } else {
        throw new Error("Invalid response");
      }
    } catch (err) {
      console.error("Rx upload error", err);
      toast.error("❌ Failed to upload prescription. Please try again.");
    }
    setUploadingRx(false);
  };

  useEffect(() => {
    if (singleproduct?.color?.length > 0) {
      fetchProductColors(singleproduct.color);
    }
  }, [singleproduct]);

  const fetchProductColors = async (colorIds) => {
    try {
      const res = await axios.post(
        `${base_url}color/byIds`,
        { ids: colorIds },
        config2,
      );
      setColorDetails(res.data);
    } catch (e) {
      console.error("Error fetching colors:", e);
    }
  };

  useEffect(() => {
    if (showToast) {
      const t = setTimeout(() => setShowToast(false), 3000);
      return () => clearTimeout(t);
    }
  }, [showToast]);

  const handleColorClick = (colorIndex) => {
    setSelectedColorIndex(colorIndex);
    const color = singleproduct.colors[colorIndex];
    if (color) {
      setAllImages(color.images || []);
      setCurrentIndex(0);
      setSelectedColor(color);
    }
  };

  useEffect(() => {
    if (wishlistState)
      setIsFilled(wishlistState.some((item) => item._id === id));
  }, [wishlistState, id]);

  const handleSizeClick = (size) => setSelectedSize(size);

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => setCurrentIndex((p) => (p + 1) % allImages.length),
    onSwipedRight: () =>
      setCurrentIndex((p) => (p - 1 + allImages.length) % allImages.length),
    trackTouch: true,
    trackMouse: false,
  });

  const currentImage = allImages[currentIndex];

  const addToCartHandler = (productId) => {
    const isFreeSize = singleproduct.sizes && singleproduct.sizes.length === 0;
    if (!selectedColor) {
      toast.error("Please select a quantity.");
      return;
    }
    if (!selectedSize && !isFreeSize) {
      toast.error("Please select a strength.");
      return;
    }
    
    // Save prescriptions if any
    if (prescriptionImages.length > 0) {
      const existing = sessionStorage.getItem("pendingPrescriptions") 
        ? JSON.parse(sessionStorage.getItem("pendingPrescriptions")) 
        : [];
      const updated = [...existing, ...prescriptionImages];
      // deduplicate by public_id or secure_url
      const unique = Array.from(new Set(updated.map(i => i.public_id || i.secure_url))).map(id => updated.find(i => (i.public_id || i.secure_url) === id));
      sessionStorage.setItem("pendingPrescriptions", JSON.stringify(unique));
    }

    const postedByUserId = singleproduct.PostedByuserId;
    dispatch(
      addToCart({
        postedByUserId,
        productId,
        selectedColor,
        selectedSize: isFreeSize ? "Free Size" : selectedSize,
        navigate,
      }),
    ).then(() => {
        // Automatically open the side-cart drawer
        const drawer = document.querySelector('.offCanvas__minicart');
        if (drawer) {
          drawer.classList.add('active');
          document.body.classList.add('offCanvas__minicart_active');
        }
    });
  };

  const PastoCheckout = (productId) => {
    const isFreeSize = singleproduct.sizes && singleproduct.sizes.length === 0;
    if (!selectedColor) {
      toast.error("Please select a quantity.");
      return;
    }
    if (!selectedSize && !isFreeSize) {
      toast.error("Please select a strength.");
      return;
    }

    // Save prescriptions
    if (prescriptionImages.length > 0) {
      const existing = sessionStorage.getItem("pendingPrescriptions") 
        ? JSON.parse(sessionStorage.getItem("pendingPrescriptions")) 
        : [];
      const updated = [...existing, ...prescriptionImages];
      const unique = Array.from(new Set(updated.map(i => i.public_id || i.secure_url))).map(id => updated.find(i => (i.public_id || i.secure_url) === id));
      sessionStorage.setItem("pendingPrescriptions", JSON.stringify(unique));
    }

    navigate("/checkout", {
      state: [
        {
          productId,
          selectedColor,
          selectedSize: isFreeSize ? "Free Size" : selectedSize,
        },
      ],
    });
  };

  const handleShareClick = () => {
    const url = window.location.href;
    const title = singleproduct.title;
    if (navigator.share) {
      navigator
        .share({ title, text: `Check out: ${title}`, url })
        .catch(console.error);
    } else if (navigator.clipboard) {
      navigator.clipboard
        .writeText(url)
        .then(() => toast.success("Link copied to clipboard!"))
        .catch(() => toast.error("Failed to copy link."));
    }
  };

  if (isLoading || !singleproduct?.colors) {
    return (
      <>
        <style>{PD_STYLES}</style>
        <div className="pd-loading">
          <div className="pd-spinner" />
          <span className="pd-loading__label">Loading product…</span>
        </div>
      </>
    );
  }

  if (!singleproduct || singleproduct.colors.length === 0) {
    return (
      <>
        <style>{PD_STYLES}</style>
        <div className="pd-loading">
          <span style={{ fontSize: "48px" }}>📭</span>
          <span className="pd-loading__label">No product data available.</span>
        </div>
      </>
    );
  }

  const discountPct = (singleproduct.oldPrice && singleproduct.oldPrice > singleproduct.price)
    ? Math.round(
        ((singleproduct.oldPrice - singleproduct.price) /
          singleproduct.oldPrice) *
          100,
      )
    : null;

  return (
    <>
      <style>{PD_STYLES}</style>

      <main className="main__content_wrapper pd-wrapper">
        {/* Breadcrumb */}
        <nav className="pd-breadcrumb" aria-label="Breadcrumb">
          <Link to="/">Home</Link>
          <span>›</span>
          <Link to="/shop">Products</Link>
          <span>›</span>
          <span>{singleproduct.title}</span>
        </nav>

        {/* Main Grid */}
        <div className="pd-main">
          {/* ── LEFT: Gallery ── */}
          <section className="pd-gallery" aria-label="Product images">
            {/* Main Image */}
            <div
              className="pd-gallery__main"
              {...swipeHandlers}
              onClick={() => setIsZoomed(!isZoomed)}
            >
              {currentImage ? (
                <img
                  className={`pd-gallery__main-img${isZoomed ? " zoomed" : ""}`}
                  src={currentImage.secure_url}
                  alt={singleproduct.title}
                />
              ) : (
                <div style={{ color: "#94a3b8", fontSize: "14px" }}>
                  No image available
                </div>
              )}
              <button
                className="pd-gallery__zoom-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsGalleryOpen(true);
                  setIsZoomed(false);
                }}
                aria-label="Open full gallery"
                type="button"
              >
                <AiOutlineZoomIn size={20} />
              </button>
              {allImages.length > 1 && (
                <div className="pd-gallery__counter">
                  {currentIndex + 1} / {allImages.length}
                </div>
              )}
            </div>

            {/* Thumbnails */}
            {allImages.length > 1 && (
              <div className="pd-gallery__thumbs">
                {allImages.map((img, i) => (
                  <button
                    key={img._id || i}
                    className={`pd-gallery__thumb${i === currentIndex ? " active" : ""}`}
                    onClick={() => {
                      setCurrentIndex(i);
                      setIsZoomed(false);
                    }}
                    aria-label={`View image ${i + 1}`}
                    type="button"
                  >
                    <img
                      src={img.secure_url}
                      alt={`Product view ${i + 1}`}
                      loading="lazy"
                    />
                  </button>
                ))}
              </div>
            )}
          </section>

          {/* ── RIGHT: Product Info ── */}
          <section className="pd-info" aria-label="Product details">
            <form onSubmit={(e) => e.preventDefault()}>
              {/* Category badge */}
              {singleproduct.category && (
                <div className="pd-info__category">
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <rect x="2" y="2" width="9" height="9" rx="1" />
                    <rect x="13" y="2" width="9" height="9" rx="1" />
                    <rect x="13" y="13" width="9" height="9" rx="1" />
                    <rect x="2" y="13" width="9" height="9" rx="1" />
                  </svg>
                  {singleproduct.category}
                </div>
              )}

              {/* Medical Badges Row */}
              <div className="pd-badge-list">
                <span className="pd-medical-badge pd-badge--verified">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
                  Quality Verified
                </span>
                <span className="pd-medical-badge pd-badge--certified">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                  Pharmacist Approved
                </span>
              </div>

              <h1 className="pd-info__title">{singleproduct.title}</h1>

              {/* Pharmacy: Strength */}
              {(singleproduct.strength || singleproduct.requiresPrescription) && (
                <div className="pd-pharmacy-row">
                  {singleproduct.strength && (
                    <div className="pd-strength-badge" title="Product Strength">
                      <span style={{ fontSize: 18 }}>⚗️</span>
                      {singleproduct.strength}
                    </div>
                  )}
                  {singleproduct.requiresPrescription && (
                    <div style={{ background: "#fff7ed", color: "#c2410c", border: "1.5px solid #fed7aa", padding: "8px 16px", borderRadius: "12px", fontSize: "12px", fontWeight: "900", textTransform: "uppercase", letterSpacing: "0.08em", display: "flex", alignItems: "center", gap: "6px" }}>
                      <span style={{ fontSize: "16px" }}>💊</span> Rx Required
                    </div>
                  )}
                </div>
              )}

              {/* Price Row */}
              <div className="pd-info__price-row">
                <div className="pd-info__price-group">
                  <span className="pd-info__price">
                    {(selectedPlan ? selectedPlan.price : singleproduct.price).toLocaleString()}

                    <span className="pd-info__currency">ETB</span>
                  </span>
                  {singleproduct.oldPrice && (
                    <span className="pd-info__old-price">
                      {singleproduct.oldPrice} ETB
                    </span>
                  )}
                  {discountPct && (
                    <span
                      style={{
                        background: "#fef2f2",
                        color: "#ef4444",
                        fontSize: "12px",
                        fontWeight: 800,
                        padding: "4px 10px",
                        borderRadius: "100px",
                        letterSpacing: "0.05em",
                      }}
                    >
                      -{discountPct}%
                    </span>
                  )}
                </div>
                <button
                  className="pd-info__share"
                  onClick={handleShareClick}
                  title="Share product"
                  type="button"
                  aria-label="Share this product"
                >
                  <FaShareFromSquare size={18} />
                </button>
              </div>

              {/* Prescription Upload Zone */}
              {singleproduct.requiresPrescription && (
                <div style={{
                  background: "linear-gradient(135deg,#fff7ed 0%,#fff 100%)",
                  border: "1.5px solid #fed7aa",
                  borderRadius: "20px",
                  padding: "20px",
                  marginBottom: "24px",
                  boxShadow: "0 4px 16px rgba(234,88,12,0.06)",
                }}>
                  {/* Header */}
                  <div style={{ display:"flex", alignItems:"center", gap:"10px", marginBottom:"14px" }}>
                    <div style={{ width:36,height:36,borderRadius:"10px",background:"#fff",border:"1px solid #fed7aa",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"18px" }}>📋</div>
                    <div>
                      <div style={{ fontSize:"13px",fontWeight:"900",color:"#9a3412",lineHeight:1.2 }}>Prescription Required</div>
                      <div style={{ fontSize:"11px",color:"#c2410c",fontWeight:"600",marginTop:"2px" }}>Upload a clear photo of your valid prescription</div>
                    </div>
                    {prescriptionImages.length > 0 && (
                      <div style={{ marginLeft:"auto",background:"#dcfce7",border:"1px solid #86efac",color:"#15803d",fontSize:"10px",fontWeight:"900",padding:"4px 10px",borderRadius:"100px",whiteSpace:"nowrap" }}>
                        ✓ {prescriptionImages.length} uploaded
                      </div>
                    )}
                  </div>

                  {/* Drop Zone */}
                  <label
                    onDragOver={(e) => { e.preventDefault(); setRxDragOver(true); }}
                    onDragLeave={() => setRxDragOver(false)}
                    onDrop={(e) => { e.preventDefault(); setRxDragOver(false); handlePrescriptionUpload(e.dataTransfer.files); }}
                    style={{
                      display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center",
                      gap:"8px", padding:"24px 16px",
                      border: rxDragOver ? "2px dashed #f97316" : "2px dashed #fdba74",
                      borderRadius:"14px",
                      background: rxDragOver ? "#fff7ed" : uploadingRx ? "#f8fafc" : "rgba(255,255,255,0.7)",
                      cursor: uploadingRx ? "not-allowed" : "pointer",
                      transition:"all 0.2s",
                    }}
                  >
                    <input
                      type="file"
                      accept="image/*"
                      multiple
                      style={{ display:"none" }}
                      disabled={uploadingRx}
                      onChange={(e) => handlePrescriptionUpload(e.target.files)}
                    />
                    {uploadingRx ? (
                      <>
                        <div style={{ width:32,height:32,border:"3px solid #fed7aa",borderTopColor:"#f97316",borderRadius:"50%",animation:"pdSpin 0.8s linear infinite" }} />
                        <span style={{ fontSize:"12px",fontWeight:"700",color:"#c2410c" }}>Uploading...</span>
                      </>
                    ) : (
                      <>
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                          <polyline points="17 8 12 3 7 8"/>
                          <line x1="12" y1="3" x2="12" y2="15"/>
                        </svg>
                        <span style={{ fontSize:"13px",fontWeight:"800",color:"#9a3412" }}>Tap to upload or drag &amp; drop</span>
                        <span style={{ fontSize:"10px",color:"#c2410c",fontWeight:"600" }}>JPG, PNG, PDF • Max 10MB per file • Multiple allowed</span>
                      </>
                    )}
                  </label>

                  {/* Uploaded Previews */}
                  {prescriptionImages.length > 0 && (
                    <div style={{ marginTop:"14px" }}>
                      <div style={{ fontSize:"10px",fontWeight:"900",color:"#94a3b8",textTransform:"uppercase",letterSpacing:"0.12em",marginBottom:"8px" }}>Uploaded Prescriptions</div>
                      <div style={{ display:"flex",gap:"8px",flexWrap:"wrap" }}>
                        {prescriptionImages.map((img, idx) => (
                          <div key={idx} style={{ position:"relative",width:"68px",height:"68px" }}>
                            <img
                              src={img.secure_url || img.url || img}
                              alt={`Rx ${idx+1}`}
                              style={{ width:"100%",height:"100%",objectFit:"cover",borderRadius:"10px",border:"1.5px solid #86efac" }}
                              onClick={() => window.open(img.secure_url || img.url || img, "_blank")}
                            />
                            <button
                              onClick={() => setPrescriptionImages(p => p.filter((_,i) => i !== idx))}
                              style={{ position:"absolute",top:-6,right:-6,width:18,height:18,borderRadius:"50%",background:"#ef4444",border:"2px solid #fff",color:"#fff",fontSize:"9px",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",lineHeight:1 }}
                            >✕</button>
                          </div>
                        ))}
                        <label style={{ width:"68px",height:"68px",borderRadius:"10px",border:"1.5px dashed #fdba74",display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",background:"rgba(255,255,255,0.8)",fontSize:"22px",color:"#f97316" }}>
                          <input type="file" accept="image/*" multiple style={{ display:"none" }} disabled={uploadingRx} onChange={(e) => handlePrescriptionUpload(e.target.files)} />
                          +
                        </label>
                      </div>
                    </div>
                  )}

                  <p style={{ margin:"12px 0 0",fontSize:"10px",color:"#c2410c",fontWeight:"600",textAlign:"center",opacity:0.8 }}>
                    ⚠️ Our pharmacist will verify your prescription before dispatch.
                  </p>
                </div>
              )}

              {/* Prescription Plans */}
              {singleproduct.requiresPrescription && singleproduct.prescriptionPlans?.length > 0 && (
                <div className="pd-plans__section">
                  <h3 className="pd-plans__title">
                    <span style={{ fontSize: 18 }}>📅</span> Prescription Plans
                  </h3>
                  <div className="pd-plans__grid">
                    {singleproduct.prescriptionPlans.map((plan, i) => (
                      <div
                        key={i}
                        className={`pd-plan-card${selectedPlan === plan ? " active" : ""}`}
                        onClick={() => setSelectedPlan(selectedPlan === plan ? null : plan)}
                      >
                        <div>
                          <div className="pd-plan-name">{plan.planName}</div>
                          <div className="pd-plan-duration">{plan.duration} • {plan.dosage}</div>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: 15 }}>
                          <div className="pd-plan-price">{plan.price.toLocaleString()} ETB</div>
                          <div className="pd-plan-check">{selectedPlan === plan ? "✓" : ""}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                  
                  {/* Deeply Integrated Plan Summary */}
                  {selectedPlan && (
                    <div style={{ 
                      background: '#f0fdfa', border: '1.5px dashed #14b8a6', borderRadius: '16px', 
                      padding: '16px', marginBottom: '24px', animation: 'pdFadeIn 0.3s ease' 
                    }}>
                      <div style={{ fontSize: '11px', fontWeight: 800, color: '#0d9488', textTransform: 'uppercase', marginBottom: '8px', letterSpacing: '0.05em' }}>
                        Selected Care Plan Summary
                      </div>
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                        <div>
                          <div style={{ fontSize: '10px', color: '#64748b', fontWeight: 700 }}>DOSAGE</div>
                          <div style={{ fontSize: '13px', color: '#0f172a', fontWeight: 700 }}>{selectedPlan.dosage}</div>
                        </div>
                        <div>
                          <div style={{ fontSize: '10px', color: '#64748b', fontWeight: 700 }}>DURATION</div>
                          <div style={{ fontSize: '13px', color: '#0f172a', fontWeight: 700 }}>{selectedPlan.duration}</div>
                        </div>
                      </div>
                      {selectedPlan.description && (
                        <div style={{ marginTop: '10px', paddingTop: '10px', borderTop: '1px solid rgba(20,184,166,0.1)' }}>
                          <div style={{ fontSize: '10px', color: '#64748b', fontWeight: 700 }}>PHARMACIST NOTES</div>
                          <div style={{ fontSize: '12px', color: '#475569', fontStyle: 'italic', lineHeight: 1.4 }}>"{selectedPlan.description}"</div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}

              <div className="pd-divider" />


              {/* Meta */}
              <div
                style={{
                  marginBottom: "16px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "6px",
                }}
              >
                {singleproduct.brand && (
                  <div className="pd-info__meta">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 7H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z" />
                      <circle cx="12" cy="12" r="3" />
                    </svg>
                    Brand: <strong>{singleproduct.brand}</strong>
                  </div>
                )}
                <div className="pd-info__meta">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke={singleproduct.quantity > 0 ? "#14b8a6" : "#94a3b8"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                  <span
                    style={{
                      color: singleproduct.quantity > 0 ? "#14b8a6" : "#94a3b8",
                      fontWeight: 700,
                    }}
                  >
                    {singleproduct.quantity > 0 ? "In Stock" : "Out of Stock"}
                  </span>
                </div>
              </div>

              {/* Description */}
              <div style={{ marginBottom: "20px" }}>
                <div
                  className={`pd-info__desc${isExpanded ? " pd-info__desc-full" : " pd-info__desc-clamped"}`}
                  dangerouslySetInnerHTML={{
                    __html: singleproduct.description,
                  }}
                />
                <button
                  type="button"
                  className="pd-info__desc-toggle"
                  onClick={() => setIsExpanded(!isExpanded)}
                >
                  {isExpanded ? "Show less ↑" : "Read more ↓"}
                </button>
              </div>

              <div className="pd-divider" />

              {/* Quantity / Color Selection */}
              {singleproduct?.colors && singleproduct.colors.length > 0 && (
                <div className="pd-section">
                  <div className="pd-section__label">Packs / Options</div>
                  <div className="pd-chips">
                    {singleproduct.colors.map((color, idx) => {
                      const label = color.color?.title || String(idx + 1);
                      return (
                        <button
                          key={color._id || idx}
                          type="button"
                          className={`pd-chip${selectedColor === color ? " active" : ""}`}
                          onClick={() => handleColorClick(idx)}
                          aria-pressed={selectedColor === color}
                        >
                          {label}
                        </button>
                      );
                    })}
                  </div>
                </div>
              )}

              {/* Strength / Size */}
              <div className="pd-section">
                <div className="pd-section__label">Strength / Size</div>
                <div className="pd-chips">
                  {singleproduct?.sizes && singleproduct.sizes.length > 0 ? (
                    singleproduct.sizes.map((size, i) => (
                      <button
                        key={i}
                        type="button"
                        className={`pd-chip${selectedSize === size ? " active" : ""}`}
                        onClick={() => handleSizeClick(size)}
                        aria-pressed={selectedSize === size}
                      >
                        {size}
                      </button>
                    ))
                  ) : (
                    <button
                      type="button"
                      className={`pd-chip${selectedSize === "Free Size" ? " active" : ""}`}
                      onClick={() => handleSizeClick("Free Size")}
                      aria-pressed={selectedSize === "Free Size"}
                    >
                      Default
                    </button>
                  )}
                </div>
              </div>

              {/* CTA Buttons - Hidden on desktop-view mobile for sticky bar if preferred, but here we keep them */}
              <div className="pd-cta">
                <button
                  type="button"
                  className="pd-btn pd-btn--cart"
                  onClick={() => addToCartHandler(singleproduct._id)}
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="9" cy="21" r="1" />
                    <circle cx="20" cy="21" r="1" />
                    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
                  </svg>
                  Add to Cart
                </button>
                <button
                  type="button"
                  className="pd-btn pd-btn--order"
                  onClick={() => PastoCheckout(singleproduct._id)}
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5 12h14M12 5l7 7-7 7" />
                  </svg>
                  Order Online
                </button>
              </div>

              {/* Trust Badges */}
              <div className="pd-trust">
                {[
                  { icon: "🔒", text: "Secure Checkout" },
                  { icon: "🚚", text: "Fast Delivery" },
                  { icon: "✅", text: "Verified Quality" },
                  { icon: "📞", text: "24/7 Support" },
                ].map(({ icon, text }) => (
                  <div key={text} className="pd-trust__item">
                    <div className="pd-trust__icon">{icon}</div>
                    <span>{text}</span>
                  </div>
                ))}
              </div>
            </form>
          </section>
        </div>

        {/* Bottom Sections */}
        <div className="pd-bottom">
          <div className="pd-bottom__section">
            <AdComponent1 />
          </div>
          <div className="pd-bottom__section">
            <RelatedProducts />
          </div>
        </div>
      </main>

      {/* Sticky Bottom Bar for Mobile */}
      <div className="pd-sticky-bar">
        <div className="pd-sticky-info">
          <span className="pd-sticky-label">Total Price</span>
          <span className="pd-sticky-price">
            {(selectedPlan ? selectedPlan.price : singleproduct.price).toLocaleString()} <small style={{ fontSize: 10 }}>ETB</small>
          </span>
        </div>
        <button 
          className="pd-sticky-btn"
          onClick={() => PastoCheckout(singleproduct._id)}
        >
          <span>Quick Buy</span>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </button>
      </div>

      {/* Lightbox */}
      {isGalleryOpen && (
        <div
          className="pd-lightbox"
          onClick={() => setIsGalleryOpen(false)}
          role="dialog"
          aria-modal="true"
          aria-label="Image gallery"
        >
          <div
            className="pd-lightbox__inner"
            onClick={(e) => e.stopPropagation()}
            {...swipeHandlers}
          >
            <button
              className="pd-lightbox__close"
              onClick={() => setIsGalleryOpen(false)}
              aria-label="Close gallery"
              type="button"
            >
              <AiOutlineClose size={20} />
            </button>

            {allImages.length > 1 && (
              <button
                className="pd-lightbox__nav pd-lightbox__nav--prev"
                onClick={() =>
                  setCurrentIndex(
                    (p) => (p - 1 + allImages.length) % allImages.length,
                  )
                }
                aria-label="Previous image"
                type="button"
              >
                ‹
              </button>
            )}

            {currentImage && (
              <img
                className={`pd-lightbox__img${isZoomed ? " zoomed" : ""}`}
                src={currentImage.secure_url}
                alt={`Product ${currentIndex + 1}`}
                onClick={() => setIsZoomed(!isZoomed)}
                style={{ cursor: isZoomed ? "zoom-out" : "zoom-in" }}
              />
            )}

            {allImages.length > 1 && (
              <button
                className="pd-lightbox__nav pd-lightbox__nav--next"
                onClick={() =>
                  setCurrentIndex((p) => (p + 1) % allImages.length)
                }
                aria-label="Next image"
                type="button"
              >
                ›
              </button>
            )}

            <div className="pd-lightbox__counter">
              {currentIndex + 1} / {allImages.length}
            </div>
          </div>
        </div>
      )}

      {/* Toast */}
      {showToast && (
        <div className="pd-toast" role="alert">
          {toastMessage}
        </div>
      )}

      <Footer />
    </>
  );
};

export default ProductDetails;
